<style src="./ParkingHistoryCard.scss" lang="scss" scoped></style>
<template>
  <div class="parkign-history-card">
    <span class="movement">{{ movementType }}</span>
    <span class="parking-name">{{ info.parking ? info.parking : 'Não informado' }}</span>
    
    <div class="employee" v-show="showEmployee || (info.movement === 'exited' && info.employee)">
      <i class="fa fa-user"></i>
      <span class="employee-name">{{  info.employee }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ParkignHistory',
    props: {
      info: {
        default: {}
      },
      showEmployee: {
        default: false
      }
    },
    computed: {
      movementType () {
        switch (this.info.movement) {
          case 'entered':
            return 'ENTRADA'
          case 'exited':
            return 'SAÍDA'
          default:
            return 'NÃO INFORMADO'
        }
      }
    }
  }
</script>